import styled from "styled-components";

export const MainTemplates = styled.div`
  display: grid;
  width: 100%;
  height: 100vh;
  grid-template-areas:
    "HD"
    "CT";
  grid-template-rows: 56px auto;
  background: ${(props) => props.theme.colors.white};
  box-sizing: border-box;
  overflow-x: hidden;
`;

export const ContentNavigation = styled.section<any>`
  width: 100%;
  height: 60px;
  position: absolute;
  display: flex;
  flex-direction: row;
  align-items: center;
  font-size: 20px;
  background: ${(props) =>
    props.headerBg === "main"
      ? props.theme.colors.mainBg
      : props.theme.colors.white};
  box-sizing: border-box;
`;

export const ContentsSection = styled.section`
  grid-area: CT;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  padding: 27px;
  flex-direction: column;
  gap: 40px;
  box-sizing: border-box;
  min-width: 0;
`;
